import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import ColorDropdownSelectorItem from './ColorDropdownSelectorItem';
import { ProductModalContext } from '../../../ProductModalContext';
import './ColorDropdownSelector.css';

const ColorDropdownSelector = ({ defaultColor, fontStyle, groupColors }) => {
    const { variantColor, setVariantColor, setSelectedVariantSKU, selectedVariantSKU, productVariantMap, baseSKU } = useContext(ProductModalContext)
    const [selectorOpen, setSelectorOpen] = useState(false);
    const [dropDownColors, setDropdownColors] = useState(groupColors);

    useEffect(() => {
        setVariantColor(defaultColor);
        setDropdownColors(groupColors.filter(v => {return v != defaultColor }))
        setSelectedVariantSKU(productVariantMap.features_map[defaultColor]);
        return () => { setSelectedVariantSKU(baseSKU) };
    }, [])

    const toggleSelector = () => setSelectorOpen(!selectorOpen);

    const handleOnClick = (color) => {
        setVariantColor(color);
        setSelectedVariantSKU(productVariantMap.features_map[color]);
        toggleSelector();
        setDropdownColors(groupColors.filter(v => {return v != color }))
    };

    return (
        <div id="color-selector-column" className="flex-center" style={fontStyle}>
            <ColorDropdownSelectorItem text={defaultColor} sku={selectedVariantSKU} onClick={groupColors.length > 1 ? toggleSelector : () => { return; }} showArrow={groupColors.length > 1} arrowDown={!selectorOpen} oneItem={groupColors.length <= 1} />

            <div id="color-selector-items" className="flex-center">
                {groupColors.length > 1 && <ColorDropdownSelectorItem text={variantColor} sku={selectedVariantSKU} relative={true} onClick={toggleSelector} showArrow={groupColors.length > 1} arrowDown={!selectorOpen} />}
                {selectorOpen && groupColors && groupColors.length > 1 && dropDownColors.map((color, index) => (
                    <ColorDropdownSelectorItem
                        key={index}
                        relative={true}
                        onClick={() => handleOnClick(color)}
                        text={color}
                    />
                ))}
            </div>
        </div>
    );
}

ColorDropdownSelector.propTypes = {
    defaultColor: PropTypes.string.isRequired,
    fontStyle: PropTypes.object,
    groupColors: PropTypes.arrayOf(PropTypes.string),
};

export default ColorDropdownSelector;
